import styled from 'styled-components';
import Content from 'gatsby-theme-core/src/components/content';

export default styled(Content)`
  p {
    margin-bottom: 0;
  }
`;
